export { default } from "./LogoText";
